import * as types from '../../utils/actionTypes'

// Active Node
const setActiveNodeAction = nodeId => ({
  type: types.SET_ADMIN_ACTIVE_NODE,
  payload: nodeId,
})

export const setActiveNode = payload =>
  dispatch => dispatch(setActiveNodeAction(payload))

// JWT
const setJwtAction = credentials => ({
  type: types.SET_JWT,
  payload: credentials,
})

export const setJwt = payload =>
  dispatch => dispatch(setJwtAction(payload))

// Login
const loginFailed = error => ({
  type: types.LOGIN_FAILED,
  payload: error,
})

export const login = (formData, history) => async (dispatch) => {
  try {
    const response = await fetch(process.env.REACT_APP_AUTHENTICATOR_URI, {
      method: 'post',
      body: JSON.stringify(formData),
      headers: { 'content-type': 'application/json' },
    })
    if (!response.ok) throw Error('Login failed')
    const data = await response.json()
    dispatch(setJwt(data.data))
    return history.push('/admin')
  } catch (error) {
    return dispatch(loginFailed())
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/actions.js